import React, { useState, useEffect } from "react";
import "./App.css";
import { TruApprovalContactForm } from "truapproval-contact";

function App() {
  const [mloSID, setMLOSID] = useState("");
  const [mloLeadsource, setMloLeadsource] = useState("");
  const [mloEmail, setMLOEmail] = useState("");
  const [webPageURL, setWebPageURL] = useState("");

  useEffect(() => {
  // Get the data that is sent to the iframe with the contentWindow
    function MloData(event) {
      if (event.data.loanOfficerUid) {
        setMLOSID(event.data.loanOfficerUid);
        setMloLeadsource(event.data.leadSource);
        setMLOEmail(event.data.loanOfficerEmail);
        setWebPageURL(event.data.webPageURL);
      }
    }
    window.addEventListener("message", MloData, false);
  }, []);

  return (
    <div className="App">
        {mloSID ?<TruApprovalContactForm
        leadSource={mloLeadsource}
        loanOfficerUID={mloSID}
        loanOfficerEmail={mloEmail}
        webPageURL={webPageURL}
      /> : null} 
    </div>
  );
}

export default App;
